const KABRISTAN_CONFIG = {
  K1: {
    name: "DPR Sahar",
    playlistId: "PLugsKQXajiMM6aV5GdyAD2ka_g_7jhseY"
  },
  K2: {
    name: "Kabristan 2nd",
    playlistId: "PLugsKQXajiMMKrpctMXh5csk2yPkSG4hf"
  },
  K3: {
    name: "Kabristan 3rd",
    playlistId: "PLugsKQXajiMOYNCHaN-Qsafi3zXbAk7Oy"

  },
  K4: {
    name: "Kabristan 4th",
    playlistId: "PLugsKQXajiMPCedwhnNCzL3fa_s0j4gzO"

  },
  K5: {
    name: "Kabristan 5th",
    playlistId: "PLugsKQXajiMMVdCMs0G661gjnYCS0q24c"

  },
  K6: {
    name: "Kabristan 6th",
    playlistId: "PLugsKQXajiMN9h-3y9IIWKD0vpPiruISu"

  },
  K7: {
    name: "Zakat 7th",
    playlistId: "PLugsKQXajiMNrrWkNWpSWwbru4B1zKJOS"

  }
};

export default KABRISTAN_CONFIG;
